import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/lib/content';

export default function CategorySection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          id="categories"
          kicker="Topics"
          title="六大主题，按你关心的方向速览"
          desc="每个板块都遵循同一套速览标准：先给要点，再给摘要，最后才是完整正文。选择感兴趣的方向直接进入。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <Link
              key={category.key}
              to={`/hot?category=${category.key}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${category.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {category.name}
                  </span>
                  <span className="whitespace-nowrap rounded-md bg-background-200 px-2 py-0.5 font-label text-xs text-foreground-600">
                    {category.count} 条
                  </span>
                </span>
                <span className="mt-2 block font-body text-sm leading-relaxed text-foreground-600">
                  {category.desc}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}